module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAADHRSTlMAgFAIGHgQQEg4IHAQGXYNAAAAqklEQVQI12NABczOVjBWq0hhUAKY6SooVii4BcRiYRKUmiio4ABkZisoihsKMQUDmYpCTKIcCooSQGagoIJiMZOgqAEDl6CgEJOChaCgAwNz2sqNCkwFmZUJDGwzprErMEnPSjFgYBEUbGZSUBQUXMDADNRmLgTUBjShUYipIVBBUQjINFVQFC4UYtoGsVhyIcRiBm9B8UTBELDL2FTFHSMMoC5ebAJmIQAAP3UabiBxrmgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab5.png
// module id = yDUv
// module chunks = 1